import { useContext, useState } from 'react';
import FormField from '../../components/FormField/FormField';
import StepHeader from '../../components/Wizard/StepHeader';
import { clearSpaces, maskClearSpecialCharacters } from '../../utils/Masks';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';

import Alert from '../../components/Alert';
import { SignUpContext } from '../../data/SignUp/SignUpContext';
import RedirectSignIn from './RedirectSignIn';

export interface SignUpLastNameProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUpLastName({
  nextPath,
  previousPath,
  handleChangeStep,
  context
}: SignUpLastNameProps) {
  const [errorRequest, setErrorRequest] = useState('');

  const { register, setValue, trigger, errors, touchedFields, getValues } =
    useContext(SignUpContext);

  function controlBackPage() {
    if (previousPath == 0 || previousPath) handleChangeStep(previousPath);
  }

  window.onpopstate = () => {
    controlBackPage();
  };

  async function checkValidateFields() {
    const validateFullName = await trigger(['lastName']);

    return new Promise((resolve) => {
      const fixedFieldsValidated = validateFullName;
      resolve(fixedFieldsValidated);
    });
  }

  function nextStep() {
    checkValidateFields().then((response) => {
      if (response && nextPath) {
        const firstName = getValues('firstName')?.trim();
        const lastName = getValues('lastName')?.trim();

        setValue('userName', `${firstName} ${lastName}`);

        handleChangeStep(nextPath);
      }
    });
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title={`Oi, ${getValues('firstName')}.`}
          description="Vamos continuar seu cadastro com algumas perguntas básicas."
        />

        <div className="form-group">
          <Alert
            message={errorRequest}
            errors={errors}
            onClose={setErrorRequest}
          />

          <FormField
            name="lastName"
            label="qual seu sobrenome?"
            type="text"
            error={errors}
            touchedFields={touchedFields}
            onKeyUp={maskClearSpecialCharacters}
            onBlur={clearSpaces}
            register={register('lastName')}
            placeholder="tudo que vem após seu nome"
            iconPrefix="personId"
          />
        </div>
      </div>

      <div className="button-group">
        <Button
          id="signup-name"
          full
          onClick={nextStep}
          disabled={!!errors?.lastName || !getValues('lastName')}
        >
          <ButtonLabel>continuar</ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          aria-label="Voltar"
          onClick={controlBackPage}
        >
          <ButtonLabel>Voltar</ButtonLabel>
        </Button>

        <RedirectSignIn context={context} />
      </div>
    </div>
  );
}
